<template>
  <div class="login-box">
    <div class="card card-outline card-primary" id="loading-container">
      <div class="card-body login-card-body">
        <p class="login-box-msg" v-if="attemptSucceed === false">Forgot password?</p>
        <p class="login-box-msg" v-if="attemptSucceed === true">Recovery link has been sent to your email. Follow instructions to set a new password.</p>

        <form v-if="attemptSucceed === false" @submit.prevent="sendRequest" method="post">
          <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="Username" v-model="username" required>
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
          </div>

          <div class="input-group mb-3">
            <input type="email" class="form-control" placeholder="Email" v-model="email" required>
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <button type="submit" class="btn btn-primary btn-block">Request new password</button>
            </div>
          </div>

          <p class="mt-3 mb-1">
            <router-link to="/login">{{ $t('Login') }}</router-link>
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Axios from "axios";

export default {
  name: 'ForgotPassword',
  components: {},
  methods: {
    sendRequest: function () {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });
      loadingInstance.show();

      Axios({
        url: '/api/v1/users/reset-password',
        data: {
          username: this.username,
          email: this.email,
          resetUrl: window.location.origin + '/reset-password/'
        },
        method: 'POST'
      }).then(() => {
        this.attemptSucceed = true;
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.$toastr.e(error.response.data.message);
        }

        this.attemptSucceed = false;
      }).finally(() => {
        loadingInstance.close();
      });
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentUser',
    ]),
  },
  created() {
  },
  mounted () {
    this.appElement = document.getElementById('application');
    this.appElement.classList.add('hold-transition', 'login-page');
  },
  beforeDestroy() {
    this.appElement.classList.remove("hold-transition", "login-page");
  },
  data(){
    return {
      appElement: null,
      email: '',
      username: '',
      appName: process.env.VUE_APP_NAME,
      attemptSucceed: false,
    }
  },
}
</script>
